import * as React from 'react';
import { Link } from 'gatsby';
// import { StaticImage } from 'gatsby-plugin-image';

import { Main } from '../styles/TabHeaderBlock';

const TabHeaderBlock = () => (
  <Main>
    <ul className="db-tab-controls">
      <li className="active">
        <Link to="/">General</Link>
      </li>
      <li>
        <Link to="/plan-and-billing/">Plan &amp; Billing</Link>
      </li>
      <li>
        <Link to="/members/">Members</Link>
      </li>
      <li>
        <Link to="/integration/">Integration</Link>
      </li>
    </ul>
  </Main>
);

export default TabHeaderBlock;
